module.exports = __webpack_public_path__ + "static/media/arrows-alt-h.8f1e1cf6.svg";